import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AviationEventFilter } from '../models/aviation-event-filter.model';

@Injectable({
  providedIn: 'root'
})
export class AviationEventFiltersService {

  private aviationEventFilterSubject$ = new BehaviorSubject<AviationEventFilter>(new AviationEventFilter());
  aviationEventFilter = this.aviationEventFilterSubject$.asObservable();

  constructor() { }

  updateAviationEventFilters(aviationEventFilter: AviationEventFilter) {
    this.aviationEventFilterSubject$.next(aviationEventFilter);
  }
}
